<template>
  <div class="ly-table">
    <div class="table-header">
      <span class="table-title"
        >{{ $t("messages.titTblServiceContInfo") }}
      </span>
    </div>
    <!-- 2022.03.14 추가 -->
    <div class="ly-flex">
      <div class="ly-sort ly-sort-his">
        <div class="sort-count">
          <p class="table-cell-all">
            {{ $t("messages.all") }} <span class="table-cell-count">{{ listCount }}</span
            >{{ $t("messages.unit") }}
          </p>
        </div>
      </div>
      <div class="ly-btn">
        <el-button plain size="small" type="excel" @click="excelDownload"
          >{{ $t("messages.btnExcel") }}<i class="icon-DownloadSimple"></i
        ></el-button>
      </div>
    </div>
    <!-- //2022.03.14 추가 -->
    <div class="table-body">
      <idc-table :tableData="tableData" :tableHeader="tableHeader" @clickRow="rowClick" :height="300"/>
    </div>
  </div>
</template>

<script>
import IdcTable from "@/components/common/IdcTable";
import { getNow, commonExcelDownload } from "@/assets/js/common.js";

export default {
  props: {
    custId: {
      default: "",
    },
  },
  components: {
    IdcTable,
  },
  data() {
    return {
      // 22.03.15 count, countList 추가
      count: "25개",
      countList: [
        {
          label: "25개",
          value: "10",
        },
      ],
      tableData: [],
      searchSttusInfo : 'N'
    };
  },
  computed: {
    listCount() {
      return this.tableData.length;
    },
    tableHeader(){
      return [
        {
          prop: "idcCdNm",
          label: "DC",
          width: 50,
        },
        {
          prop: "svcSttusCdHnglNm",
          // label: "서비스상태",
          label: this.$t("messages.lblServiceState"),
          width: 70,
        },
        {
          prop: "svcNo",
          //label: "서비스번호",
          label: this.$t("messages.lblServiceNumber"),
          width: 60,
        },
        {
          prop: "svcContId",
          //label: "서비스계약ID",
          label: this.$t("messages.lblSvcContId"),
          width: 70,
        },
        {
          prop: "svcTypeCdHnglNm",
          // label: "서비스",
          label: this.$t("messages.lblService"),
          width: 100,
        },
        {
          prop: "svcItemDivIcisCdNm",
          // label: "상세구분",
          label: this.$t("messages.lblDtlClassificate"),
          width: 60,
        },
        {
          prop: "svcItemIcisCdNm",
          // label: "상세유형",
          label: this.$t("messages.lblDtlType"),
          width: 200,
        },
        {
          prop: "itemQnty1",
          //label: "수량",
          label: this.$t("messages.lblQuantity"),
          width: 60,
        },
      ];
    }
  },
  created() {},
  mounted() {
    this.$store.dispatch("userInfoStore/getCustLoginCustInfo").then(data => {
      this.custId = data.custId;

      this.getSvcDtlItemContList();
    });
  },
  methods: {
    getSvcDtlItemContList() {
      console.log("getSvcDtlItemContList=========>"+this.custId);
      this.$BIZ_SERVICE
        .post(this.$API_URLS.Cus.getSvcDtlItemContList, {
          custId: this.custId,
          paging: false,
          srchSvcSttusCd : this.searchSttusInfo,
        })
        .then((res) => {
          if (res.data) {
            this.tableData = res.data.resData;
            this.tableData.forEach((obj) => {
              obj.svcItemIcisCdNm = obj.svcItemIcisCd1Nm;
              if (obj.svcItemIcisCd2Nm) {
                obj.svcItemIcisCdNm = obj.svcItemIcisCdNm + ' / ' + obj.svcItemIcisCd2Nm;
              }
            });
          } else {
            this.tableData = [];
          }
        })
        .catch((error) => {})
        .finally(() => {});
    },
    rowClick(col,row) {
      //this.$EventBus.$emit("serviceContractListClickRow", col, row);
      this.$emit("serviceContractListClickRow", col, row);
    },
    excelDownload(){
      commonExcelDownload(
        this.$BIZ_SERVICE,
        this.$API_URLS.Com.excelDownloadByService, 
        this.$t('messages.titTblServiceContInfo') +"_" + getNow() + ".xlsx",
        "getSvcContList",
        this.tableHeader,
        { 
          custId : this.custId,
          srchSvcSttusCd : this.searchSttusInfo,
        }
      );
    }
  },
};
</script>

<style>

.ly-btn{
  padding-bottom:10px;
}
</style>
